import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const UserLogin = () => {
  const location = useLocation();
  React.useEffect(() => {
    if (location.state && location.state.message) {
      toast.success(location.state.message);
    }
  }, [location.state]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loader, setLoader] = React.useState(false);
  const [inputType, setInputType] = React.useState("password");
  const togglePassword = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const [formData, setFormData] = React.useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const [isLoggedInFT, setIsLoggedInFT] = React.useState(false);
  window.localStorage.setItem("IsLoggedInFT", isLoggedInFT);

  let name, value;
  const handleChange = (event) => {
    event.preventDefault();
    name = event.target.name;
    value = event.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (input) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(input);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password } = formData;
    if (!email || !password) {
      toast.error("Please fill all fields!");
    } else if (!validateEmail(email)) {
      toast.error("Email Address is not invalid!");
    } else {
      setLoader(true);
      try {
        const response = await axios.post(`${apiUrl}checkUserFT`, formData);
        const data = response.data;
        if (response.status === 200 && data.message === "Login Successfully!") {
          setIsLoggedInFT(true);
          window.localStorage.setItem("Fttoken", data.data);
          window.localStorage.setItem("FtIsLoggedIn", true);
          window.localStorage.setItem("FtuserName", data.name);
          window.localStorage.setItem("FtIdUser", data.id);
          toast.success("Login successfully!");
          setTimeout(() => {
            navigate("/productlists");
          }, 2000);
        } else {
          toast.error("Login failed.");
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        if (error.response && error.response.status === 401) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Login failed. Please try again.");
        }
      }
    }
  };
  return (
    <div>
      <Navbar />
      <div className="container">
        <ToastContainer />
        <form method="post" className="form-frontend">
          <h1>User Login</h1>
          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Email Address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mb-5">
            <label className="text-sm mb-2 pl-1 block">Password</label>
            <input
              type={inputType}
              name="password"
              className="form-control"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <div className="togglePasswordIcon" onClick={togglePassword}>
              <span className="cursor-pointer text-gray-400">
                {inputType === "password" ? (
                  <VisibilityOffOutlinedIcon sx={{ fontSize: "17px" }} />
                ) : (
                  <VisibilityOutlinedIcon sx={{ fontSize: "17px" }} />
                )}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="btn-quote mt-3"
            onClick={handleSubmit}
          >
            Login
            <LoginOutlinedIcon sx={{ fontSize: "20px", marginLeft: "10px" }} />
          </button>
          {loader && (
            <div className="loader-container">
              <div className="loader text-sm text-gray-400 text-center block">
                Request is in process please wait....
              </div>
            </div>
          )}

          <p className="mt-5 text-sm text-gray-500 hover:underline">
            <Link to="/signUp">Don't have an account? Create Account</Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default UserLogin;
